export const SHOPIFY_URL = '[PASTE SHOPIFY PRODUCT LINK HERE]'
